import React, { useCallback, useState } from 'react'
import { useNotification } from '../../../../hooks/useNotification';
import { useErrorInputs } from '../../../../hooks/useErrorInputs';
import { useForm } from '../../../../hooks/useForm';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import { ActionButtons } from '../../../../components/others/ActionButtons';
import { ChartReportForm } from './ChartReportForm';
import { MenuAndSubmenu } from './MenuAndSubmenu';
import { ManageActions } from './ManageActions';
import Close from '@mui/icons-material/Close';
import Edit from '@mui/icons-material/Edit';
import Add from '@mui/icons-material/Add';

export const ManageConfiguration = ({ data, typeAction, isDisabled, isEdit, addedConfiguration, t }) => {
    const [values, handleInputChange, handleDirectInputChange, , reset] = useForm(data);
    const [errorInputs, , resetErrors, validForm] = useErrorInputs({});
    const [selectedItem, setSelectedItem] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [sendNotification] = useNotification();

    const handleOpenModal = (item = null) => {
        reset();
        setSelectedItem(item);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        resetErrors();
        reset();
        setSelectedItem(null);
    };

    const setData = useCallback((key, val) => {
        handleDirectInputChange(key, val);
    }, []);

    const saveIfValid = (condition, errorMsg) => {
        if (condition) {
            addedConfiguration('configuration', JSON.stringify(values));
            handleCloseModal();
        } else
            sendNotification({ msg: errorMsg, variant: 'error' });
    };

    const handleSave = () => {
        if (['MENU', 'SUBMENU'].includes(typeAction)) {
            saveIfValid(
                'table' in values && values.table.length > 1,
                'Debe agregar por lo menos dos columnas a la tabla.'
            );
        } else if (['BUTTON', 'API', 'FLOW_PROCESS'].includes(typeAction)) {
            saveIfValid(
                validForm(['accion', 'icon', 'color', 'type'], values),
                'Debe completar el formulario.'
            );
        } else if (typeAction === 'CHART_REPORT') {
            saveIfValid(
                values?.charts?.length > 0,
                'Debe agregar por lo menos una gráfica.'
            );
        }
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                        {t('interface.configuration')}
                    </Typography>
                    <Tooltip title={t(isEdit ? t('edit') : t('add'))}>
                        <span>
                            <IconButton
                                disabled={isDisabled}
                                onClick={() => handleOpenModal()}
                            >
                                {isEdit ? <Edit /> : <Add />}
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            </Box>

            <Dialog open={openModal} fullWidth maxWidth='md' >
                <DialogTitle>
                    <Typography variant="h5" component="span">{t('interface.createEditConfiguration')}</Typography>
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    {['MENU', 'SUBMENU'].includes(typeAction) &&
                        <MenuAndSubmenu
                            data={data}
                            handleSave={setData}
                            handleCloseModal={handleCloseModal}
                            t={t}
                        />
                    }
                    {
                        ['BUTTON', 'API', 'FLOW_PROCESS'].includes(typeAction) &&
                        <ManageActions
                            values={values}
                            errorInputs={errorInputs}
                            listActions={false}
                            data={selectedItem || {}}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            handleCloseModal={handleCloseModal}
                            t={t}
                        />
                    }
                    {
                        ['CHART_REPORT'].includes(typeAction) &&
                        <ChartReportForm
                            data={data}
                            handleDirectInputChange={handleDirectInputChange}
                            t={t}
                        />
                    }
                </DialogContent>
                <DialogActions>
                    <ActionButtons onSubmit={handleSave} onCancel={handleCloseModal} />
                </DialogActions>
            </Dialog>
        </Box>
    );
}    